(() => {
  const form = document.querySelector('[data-mpto-form]');
  if (!form) return;
  form.addEventListener('submit', (event) => {
    if (form.dataset.hasProvider === 'true') return;
    event.preventDefault();
    const message = form.querySelector('[data-mpto-message]');
    message.textContent = 'Para consultar el seguimiento, inicia sesión y abre el pedido correspondiente.';
    message.classList.add('is-alert');
    setTimeout(() => { window.location.href = form.action; }, 1300);
  });
})();
